import conf from './_conf';
import { workName, emitUpload } from './_upload';

export const setAnalyzePoints = vnode => {
  let vnodeList = [vnode];
  // 如果有子节点，则加入循环
  if (vnode.children) {
    vnodeList = vnodeList.concat(vnode.children);
  }
  let index = -1;
  while (index < vnodeList.length - 1) {
    index++;
    let item = vnodeList[index];
    // 如果有子节点，则加入循环，select结构除外
    if (item.children && item.tag !== 'select' && item.tag !== 'option') {
      vnodeList = vnodeList.concat(item.children);
    }
    if (!item.data || (!item.data.staticClass && !item.data.class)) continue;
    // 获取静态、动态类名
    let staticClass = item.data.staticClass
      ? item.data.staticClass.split(' ')
      : [];
    let dynamicClass = item.data.class || [];
    let realClassArr = [].concat(staticClass, dynamicClass);
    // 遍历所有类名
    cList: for (let j = 0; j < realClassArr.length; j++) {
      // 因格式问题，有些类名识别并不准确，需做过滤和二次处理
      if (
        !realClassArr[j] ||
        realClassArr[j] == ' ' ||
        typeof realClassArr[j] !== 'string'
      )
        continue cList;
      let realClassName = realClassArr[j].replace(/(\s|\\n)*/g, '');

      let pointConf = conf[workName].event[realClassName];
      if (pointConf) {
        addEvent(item, pointConf);
        break cList;
      }
    }
  }
};

const addEvent = (vnode, pointConf) => {
  if (vnode.clickPoint) return;

  if (!vnode.data.on) vnode.data.on = {};
  pointConf.map(item => {
    if (vnode.data.on[item.type]) {
      let _event = vnode.data.on[item.type];
      vnode.data.on[item.type] = function () {
        let _self = this;
        let pointValue = '';
        if (vnode.data && vnode.data.attrs && vnode.data.attrs.pointValue) {
          pointValue = vnode.data.attrs.pointValue;
        }
        emitUpload(item.event, item, pointValue);
        let args = Array.prototype.slice.call(arguments);
        // 可能存在多个事件绑定
        if (_event instanceof Function) {
          _event.apply(this, args);
          return;
        }
        if (_event instanceof Array) {
          _event.map(item => {
            item.apply(_self, args);
          });
          return;
        }
      };
    } else {
      vnode.data.on[item.type] = function () {
        let pointValue = '';
        if (vnode.data && vnode.data.attrs && vnode.data.attrs.pointValue) {
          pointValue = vnode.data.attrs.pointValue;
        }
        emitUpload(item.event, item, pointValue);
      };
    }
  });
  vnode.clickPoint = true;
};

export const emitEvent = key => {
  if (!conf[workName].event[key]) return;
  conf[workName].event[key].map(item => {
    emitUpload(item.event, item);
  });
};
